<template>
  <v-container grid-list-xs fluid>
    <v-row align="end" class="ml-8">
      <v-col cols="12" class="py-0">
        <v-radio-group
          v-model="selectedSupplierType"
          row
          :disabled="$apollo.loading"
          class="my-0 py-0"
        >
          <v-radio
            v-for="sType in supplierTypes"
            :key="sType"
            :value="sType"
            class="pr-2"
            hide-details
          >
            <template v-slot:label>
              <v-icon>{{ supplierTypeIcon(sType) }}</v-icon>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row justify="center" align="baseline">
      <v-col cols="12">
        <v-container>
          <v-row align="baseline">
            <v-menu offset-x bottom right>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon text-xs-center class="mr-1">
                  <v-icon>{{ supplierTypeIcon(selectedSupplierType) }}</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        >Choose Supplier Type</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-container fluid grid-list-xs>
                  <v-row>
                    <v-radio-group v-model="selectedSupplierType">
                      <v-radio
                        v-for="sType in supplierTypes"
                        :key="sType"
                        :label="sType"
                        :value="sType"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                </v-container>
              </v-card>
            </v-menu>

            <v-autocomplete
              label="Select Supplier and Service"
              :items="items"
              item-text="label"
              item-value="serviceId"
              v-model="selectedItemId"
              :loading="$apollo.loading"
              :disabled="$apollo.loading"
              :outlined="outlinedInputs"
              clearable
              :search-input.sync="supplierSearch"
              @click:clear="onSupplierClear"
              hide-details
            ></v-autocomplete>
            <v-select
              class="ml-1"
              v-if="selectedServiceExtras.length > 0"
              :items="selectedServiceExtras"
              label="Select Extras"
              v-model="selectedExtras"
              @input="handleExtraSelection"
              :outlined="outlinedInputs"
              item-text="name"
              item-value="id"
              multiple
              chips
              deletable-chips
              small-chips
              hide-details
            ></v-select>
            <v-select
              class="ml-1"
              v-if="selectedServiceLinkedServices.length > 0"
              :items="selectedServiceLinkedServices"
              label="Select Linked Services"
              v-model="selectedLinkedServices"
              :outlined="outlinedInputs"
              item-text="label"
              item-value="serviceId"
              multiple
              chips
              deletable-chips
              small-chips
              hide-details
            ></v-select>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-container fluid>
      <v-row>
        <v-col class="py-0">
          <v-select
            label="Starting Day"
            :items="dayNumbers"
            v-model="startingDay"
            :outlined="outlinedInputs"
            hide-details
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            :label="durationLabel"
            :items="durationNumbers"
            v-model="duration"
            :outlined="outlinedInputs"
            hide-details
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-btn
            color="primary"
            text
            :disabled="selectedItemId == ''"
            @click="onAdd"
            x-large
          >
            <v-icon left>mdi-plus-circle</v-icon>Add
          </v-btn>

          <v-btn
            color="primary"
            text
            :disabled="selectedItemId == ''"
            @click="onAdd(false)"
            x-large
          >
            <v-icon left>mdi-plus-circle</v-icon>Add (Same Date)
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <div v-if="debug">
      <p>destinationId: {{ destinationId }}</p>
      <p>supplierNameFilter : {{ supplierNameFilter }}</p>
      <p>suppliersSearch: {{ supplierSearch }} - {{ selectedItemId }}</p>
    </div>
  </v-container>
</template>

<script>
import { SUPPLIER_TYPES } from "../../../../constants/supplierTypes";
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import { SERVICES_SEARCH_QUERY } from "../../../../constants/graphql";
import { removeGQLTypename, sortBy } from "../../../../helpers";
import { uniqueByProp } from "../../../../helpers/index";
var randomize = require("randomatic");
export default {
  name: "OpenGroupItemQuickAdd",
  props: {
    destinationId: { type: String },
    groupDuration: { type: Number },
    groupAdults: { type: Number, default: 0 },
    groupChildren: { type: Number, default: 0 },
  },
  mixins: [SupplierTypeIconMixin],
  data() {
    return {
      debug: false,
      selectedSupplierType: "ACCOMMODATION",
      supplierTypes: SUPPLIER_TYPES,
      startingDay: 1,
      duration: 1,
      services: {},
      items: [],
      selectedItemId: "",
      selectedExtras: [],
      supplierNameFilter: null,
      searchTimeout: null,
      searchDebounceTime: 700,
      supplierSearch: "",
      selectedLinkedServices: [],
    };
  },
  methods: {
    onAdd(updateDays = true) {
      let selectedItem = this.items.find(
        (i) => i.serviceId == this.selectedItemId
      );
      selectedItem.extras = [
        ...this.selectedServiceExtras
          .filter((e) => this.selectedExtras.indexOf(e.id) != -1)
          .map((e) => ({
            extraId: e.typeId,
            name: e.name,
            startDay: this.startingDay,
            duration: this.duration,
          })),
      ];

      const parentItemUid = randomize("Aa0", 32);
      const itemsToAdd = [selectedItem];

      if (this.selectedLinkedServices.length > 0) {
        this.selectedLinkedServices.forEach((linkedServiceId) => {
          const linkedService = this.selectedServiceLinkedServices.find(
            (ls) => ls.serviceId === linkedServiceId
          );
          if (linkedService) {
            itemsToAdd.push(linkedService);
          }
        });
      }

      itemsToAdd.forEach((item, index) => {
        const isLinkedService = index > 0;
        this.$emit("onAddItem", {
          ...item,
          serviceType: item.serviceTypeName || this.selectedSupplierType,
          id: randomize("Aa0", 32),
          uid: isLinkedService ? randomize("Aa0", 32) : parentItemUid,
          parentUid: isLinkedService ? parentItemUid : undefined,
          startDay: this.startingDay,
          duration: this.duration,
          order: 0,
          ratePlan: "",
          includeMarkup: false,
          optional: false,
          included: true,
          hidden: false,
          qty: item.stdOccupancy
            ? Math.ceil(
                (Number(this.groupAdults) + Number(this.groupChildren)) /
                  Number(item.stdOccupancy)
              ) || 1
            : 1,
          adults: this.groupAdults,
          children: this.groupChildren,
          extras: item.extras ? [...item.extras] : [],
        });
      });

      if (updateDays) {
        this.updateDays();
      }
      this.$nextTick(() => {
        this.selectedItemId = null;
        this.selectedLinkedServices = [];
      });
    },
    updateDays() {
      let max = this.groupDuration;
      if (this.selectedSupplierType == "ACCOMMODATION") {
        max--;
      }
      if (this.startingDay < max) {
        this.startingDay = this.startingDay + this.duration;
      }
      this.duration = 1;
    },
    onSupplierClear() {
      this.selectedItemId = "";
      this.supplierNameFilter = "";
    },
    handleExtraSelection(newSelection) {
      const mandatoryExtras = this.selectedServiceExtras
        .filter((extra) => extra.isMandatory)
        .map((extra) => extra.id);

      if (mandatoryExtras.length > 0) {
        this.selectedExtras = [
          ...new Set([...newSelection, ...mandatoryExtras]),
        ];
      }
    },
  },

  watch: {
    selectedSupplierType() {
      this.selectedItemId = "";
      this.startingDay = 1;
      this.duration = 1;
    },
    supplierSearch(newVal) {
      clearTimeout(this.searchTimeout);

      if (!this.selectedItemId || this.selectedItemId == "") {
        this.searchTimeout = setTimeout(() => {
          this.supplierNameFilter = newVal;
        }, this.searchDebounceTime);
      }
    },
    selectedItemId(newItemId) {
      this.$nextTick(() => {
        if (newItemId && this.selectedServiceExtras.length > 0) {
          const mandatoryExtras = this.selectedServiceExtras
            .filter((extra) => extra.isMandatory)
            .map((extra) => extra.id);

          if (mandatoryExtras.length > 0) {
            this.selectedExtras = [
              ...new Set([...this.selectedExtras, ...mandatoryExtras]),
            ];
          }
        } else {
          this.selectedExtras = [];
        }
        this.selectedLinkedServices = [];
      });
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    durationLabel: function () {
      return this.selectedSupplierType == "ACCOMMODATION"
        ? "Duration (Nights)"
        : "Duration (Days)";
    },
    dayNumbers: function () {
      let max = this.groupDuration;
      if (this.selectedSupplierType == "ACCOMMODATION") {
        max--;
      }
      return [...Array(max).keys()].map((x) => (x = x + 1));
    },
    durationNumbers: function () {
      let max = this.groupDuration - this.startingDay;
      if (this.selectedSupplierType != "ACCOMMODATION") {
        max++;
      }
      return [...Array(max).keys()].map((x) => (x = x + 1));
    },
    selectedService() {
      if (this.selectedItemId != "") {
        const s = this.items.find((i) => i.serviceId == this.selectedItemId);
        if (s) {
          return { ...s };
        }
      }
      return null;
    },
    selectedServiceExtras() {
      return this.selectedService && this.selectedService.extras.length > 0
        ? [...this.selectedService.extras]
        : [];
    },
    selectedServiceLinkedServices() {
      return this.selectedService &&
        this.selectedService.linkedServices.length > 0
        ? [...this.selectedService.linkedServices]
        : [];
    },
  },

  apollo: {
    services: {
      query: SERVICES_SEARCH_QUERY,
      variables() {
        return {
          first: 50,
          filter: {
            service_type: this.selectedSupplierType,
            supplierName_contains: this.supplierNameFilter,
            destinationId: this.destinationId,
            not_in_use_eq: false,
          },
          extraFilter: {
            validTo_gte: new Date().toISOString(),
          },
        };
      },
      result({ data }) {
        if (data && data.services && data.services.edges) {
          this.items = data.services.edges
            .filter(
              (item) => item.node.supplier && !item.node.supplier.notInUse
            )
            .map((node) => {
              const linkedServices = node.node.linkedServices.edges
                ? node.node.linkedServices.edges.map(removeGQLTypename)
                : [];

              const linkedServicesLabel =
                linkedServices.length > 0
                  ? `, (${linkedServices.length} Linked Services)`
                  : "";
              return {
                label: `${node.node.supplier.name} / ${
                  node.node.supplier.code
                } - ${node.node.name} (${
                  uniqueByProp(
                    [...node.node.extras.edges.map(removeGQLTypename)],
                    "typeId"
                  ).length
                } Extras)${linkedServicesLabel}`,
                stdOccupancy: node.node.stdOccupancy,
                maxOccupancy: node.node.maxOccupancy,
                serviceTypeName: node.node.supplier.serviceType,
                serviceId: node.node.id,
                supplierId: node.node.supplier.id,
                serviceName: node.node.name,
                supplierName: node.node.supplier.name,
                startDay: this.startingDay,
                duration: this.duration,
                extras:
                  node.node.extras.edges.length > 0
                    ? uniqueByProp(
                        [...node.node.extras.edges.map(removeGQLTypename)],
                        "typeId"
                      ).sort((a, b) =>
                        a["name"]
                          .toLowerCase()
                          .localeCompare(b["name"].toLowerCase())
                      )
                    : [],
                linkedServices: linkedServices.map((ls) => {
                  return {
                    label: `${ls.supplier.name} / ${ls.supplier.code} - ${ls.name}`,
                    stdOccupancy: ls.stdOccupancy,
                    maxOccupancy: ls.maxOccupancy,
                    serviceTypeName: ls.supplier.serviceType,
                    serviceId: ls.id,
                    supplierId: ls.supplier.id,
                    serviceName: ls.name,
                    supplierName: ls.supplier.name,
                    startDay: this.startingDay,
                    duration: this.duration,
                    extras: [],
                  };
                }),
              };
            })
            .sort(sortBy("label"));
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/open-groups/builder/OpenGroupItemQuickAdd.vue